import React, { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { SaleType } from '../../../types';
import { PaymentOptions } from './PaymentOptions';
import { PaymentOptionCard } from './PaymentOptionCard';

interface Props {
  saleType: SaleType;
  selectedTerm: any;
  isCalculating?: boolean;
  financePricing: Record<string, any>;
  onSelectOption?: (term: string) => void;
}

export const FinancePaymentOption = ({
  saleType,
  selectedTerm,
  financePricing,
  onSelectOption,
  isCalculating = false,
}: Props) => {
  const classes = useStyles();

  const renderBySaleType: Record<SaleType, ReactNode> = {
    [SaleType.Cash]: null,
    [SaleType.Financing]: (
      <Stack gap="1rem">
        <Box className="financingCards">
          {Object.entries(financePricing).map(([term, price]) => (
            <PaymentOptionCard
              paymentOption={price}
              isCalculating={isCalculating}
              isSelected={selectedTerm === term}
              onSelectOption={() => {
                onSelectOption?.(term);
              }}
            />
          ))}
        </Box>

        <RenderWithCondition condition={!!financePricing[selectedTerm]}>
          <PaymentOptions payment={financePricing[selectedTerm]!} saleType={saleType} />
        </RenderWithCondition>
      </Stack>
    ),
  };

  return <Box className={classes.container}>{renderBySaleType[saleType]}</Box>;
};

const useStyles = makeStyles({
  container: {
    gap: '12px',
    display: 'flex',
    flexDirection: 'column',

    '& .financingCards': {
      gap: '0.5rem',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(12rem, 1fr))',
    },
  },
});
